var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSobre(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0526 16.5292H3.94737L0 19.4251V3.01462C0 1.42184 1.77632 0.118652 3.94737 0.118652H21.0526C23.2237 0.118652 25 1.42184 25 3.01462V13.6332C25 15.226 23.2237 16.5292 21.0526 16.5292Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 5.9292H14.3784V13.2585H11V5.9292Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6892 5.10026C13.6221 5.10026 14.3784 4.50364 14.3784 3.76766C14.3784 3.03169 13.6221 2.43506 12.6892 2.43506C11.7563 2.43506 11 3.03169 11 3.76766C11 4.50364 11.7563 5.10026 12.6892 5.10026Z",
    fill: "#D3D3D3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_435"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSobre);
export default __webpack_public_path__ + "static/media/sobre.184e613a06e814982d4c3bb77b705d51.svg";
export { ForwardRef as ReactComponent };